/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Samples_Edit_Sample_Marked_ShippedInputs */

const en_samples_edit_sample_marked_shipped = /** @type {(inputs: Samples_Edit_Sample_Marked_ShippedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sample marked as shipped`)
};

const es_samples_edit_sample_marked_shipped = /** @type {(inputs: Samples_Edit_Sample_Marked_ShippedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muestra marcada como enviada`)
};

/**
* | output |
* | --- |
* | "Sample marked as shipped" |
*
* @param {Samples_Edit_Sample_Marked_ShippedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const samples_edit_sample_marked_shipped = /** @type {((inputs?: Samples_Edit_Sample_Marked_ShippedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Samples_Edit_Sample_Marked_ShippedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_samples_edit_sample_marked_shipped(inputs)
	return es_samples_edit_sample_marked_shipped(inputs)
});